import * as base64arraybuffer from 'base64-arraybuffer';
import { sha256 } from 'js-sha256';

type HashInput = string | ArrayBuffer | Uint8Array;

function digest(parts: HashInput[]) {
  const hash = sha256.create();
  parts.forEach((part) => hash.update(part));
  return hash;
}

/** SHA-256 of the parts in order (UTF-8 for strings), as lowercase hex. */
export function sha256Hex(...parts: HashInput[]): string {
  return digest(parts).hex();
}

/** SHA-256 of the parts in order (UTF-8 for strings), as base64. */
export function sha256Base64(...parts: HashInput[]): string {
  return base64arraybuffer.encode(digest(parts).arrayBuffer());
}
